
import { useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import { DateFilterOperator, NumberFilterOperator, TextFilterOperator } from "components/shared/filters";

import moment from "moment";
import { formatDate } from "utils/date-utils";


type UseExistingAttachmentsColumnsResult = [
  GridColDef[]
];

type UseExistingAttachmentsColumnsSignature = () => UseExistingAttachmentsColumnsResult;

const useExistingAttachmentsColumns: UseExistingAttachmentsColumnsSignature = () => {
  const columnBase: GridColDef[] = [
    {
      field: 'workItemName', headerName: 'Work Item Name', flex: 1, minWidth: 200, sortable: true, resizable: true, hideable: false, headerClassName: 'header', hideSortIcons: false, disableReorder: true,
      filterOperators: TextFilterOperator,
    },
    {
      field: 'attachmentName', headerName: 'Attachment Name', minWidth: 200, sortable: true, resizable: true, hideable: false, headerClassName: 'header', hideSortIcons: false, disableReorder: true,
      filterOperators: TextFilterOperator,
    },
    {
      field: 'attachmentType', headerName: 'Type', width: 150, sortable: true, resizable: true, hideable: false, headerClassName: 'header', hideSortIcons: false, disableReorder: true,
      filterOperators: TextFilterOperator,
    },
    {
      field: 'isAttachementFileOrURL', headerName: 'L/F/S', width: 150, sortable: true, resizable: true, hideable: true, headerClassName: 'header', hideSortIcons: false,
      renderHeader: (params) => {
        return (
          <Tooltip title="Link, File, SFTP" arrow>
            <div>{"L/F/S"}</div>
          </Tooltip>
        )
      },
    },
    {
      field: 'version', headerName: 'Version', width: 150, sortable: true, resizable: true, hideable: true, headerClassName: 'header', hideSortIcons: false,
      filterOperators: NumberFilterOperator,
      renderCell: (params) => {
        const version = params.value.toString();
        return (
          <div>
            {version}
          </div>
        );
      }
    },
    {
      field: 'modifiedOn', headerName: 'Date Modified', width: 150, sortable: true, resizable: true, hideable: true, headerClassName: 'header', hideSortIcons: false, type: 'date',
      valueGetter: (value) => {
        return !value ? null : moment.utc(value).toDate();
      },
      filterOperators: DateFilterOperator,
      renderCell: (params) => {
        const modifiedDate = params.value;
        return (
          <div>
            {formatDate(modifiedDate)}
          </div>
        );
      }
    },
    { field: 'modifiedByName', headerName: 'Modified By', width: 150, sortable: true, resizable: true, hideable: true, headerClassName: 'header', hideSortIcons: false, filterOperators: TextFilterOperator },
    
  ];

  const [columns, setColumns] = useState<GridColDef[]>(columnBase);

  useEffect(() => {
    let newColumns: GridColDef[] = [];
    newColumns.push(...columnBase);

    setColumns(newColumns);
  }, []);

  return [
    columns
  ];
};

export default useExistingAttachmentsColumns;